import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import ReactTable, { ReactTableDefaults } from 'react-table';

import {
  Loading,
  PhishingTemplateInTableMenu,
  TempStatistics,
  ReactTableFilterDatePicker,
  ReactTableSearch,
  ReactTablePagination,
  ReactTableHeaderText,
  PhishingTemplateInTableCheck
} from 'components';

import { Icon, Label, Popup, Image } from 'semantic-ui-react';
import { Checkbox } from 'material-ui';

import * as commonVar from 'libs/commonVar';

import moment from 'moment';
import 'moment/locale/ko';
import 'moment/locale/ja';

import classNames from 'classnames/bind';
import styles from './PhishingTemplateList.css';
const cx = classNames.bind(styles);

moment.locale(localStorage.getItem('language'));
class PhishingTemplateList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allChecked: false
    };
  }

  // 전체 선택 체크박스 제어
  setAllCheck = value => {
    this.setState({
      allChecked: value
    });
  };

  render() {
    const { formatMessage } = this.props.intl;
    const { data, fromNowView, isAuth, ...rest } = this.props;
    // 검색 (상단)
    const { searchObj } = this.props;
    // 필터
    const {
      handleChangeDateFilter,
      isBasicFilter,
      phishingLevelFilter,
      cancelCheck,
      downloadTypeTemplateFilter,
      cancleCheck,
      filterClose,
      executeFilter,
      onFilterCancel
    } = this.props;

    // 현재 페이지 이동 (하단)
    const { handlePagination } = this.props;

    const { setAllCheck } = this;
    const { allChecked } = this.state;

    const columns = [
      {
        Header: <ReactTableHeaderText title={<Icon name="setting" />} />,
        resizable: false,
        sortable: false,
        width: 130,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'justify-center'),
        Cell: ({ original }) => {
          return <PhishingTemplateInTableMenu isAuth={isAuth} phishingInfo={{ ...original }} />;
        }
      },
      {
        // 피싱No
        Header: <ReactTableHeaderText title={'No'} />,
        accessor: 'phishingNo',
        sortable: true,
        resizable: false,
        minWidth: 80,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center number-text'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value) {
            printValue = value;
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            {
              key: '1',
              text: defineMessages(formatMessage({ id: 'PhishingTemplateList_2', defaultMessage: '기 본' })),
              value: 1
            },
            {
              key: '0',
              text: defineMessages(formatMessage({ id: 'PhishingTemplateList_3', defaultMessage: '사용자' })),
              value: 0
            }
          ];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'PhishingTemplateList_1', defaultMessage: '구분' }))}
              // filter={
              //   <ReactTableFilterDropdown
              //     listItem={listItem}
              //     filter={searchObj.filterData}
              //     searchObj={searchObj}
              //     // handleChangeFilter={handleChangeFilter}
              //     column={rest.column.id}
              //   />
              // }
            />
          );
        },
        accessor: 'serviceNo',
        id: 'isBasic',
        sortable: true,
        resizable: false,
        minWidth: 83,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center', 'template-class-label'),
        Cell: ({ value }) => {
          let printValue = (
            <Label basic size="small" className={cx('template-type-label color-temp-system')}>
              {defineMessages(formatMessage({ id: 'ExamTemplateList_2', defaultMessage: '기 본' }))}
            </Label>
          );
          if (value) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-temp-user')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_3', defaultMessage: '사용자' }))}
              </Label>
            );
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'PhishingTemplateList_10', defaultMessage: '피싱 단계' }))}
            />
          );
        },
        accessor: 'phishingLevel',
        id: 'phishingLevel',
        sortable: true,
        resizable: false,
        minWidth: 120,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: props => {
          let printValue = '-';
          printValue = (
            <Label basic size="small" className={cx('template-type-label color-temp-phishing')}>
              {props.value
                ? props.value + defineMessages(formatMessage({ id: 'PhishingTemplateList_13', defaultMessage: '단계' }))
                : '-'}
            </Label>
          );
          return printValue;
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'PhishingTemplateList_5', defaultMessage: '템플릿명' }))}
          />
        ),
        accessor: 'phishingName',
        sortable: true,
        minWidth: 300,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td')
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamTemplateList_17', defaultMessage: '등록일시' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={data => {
                    handleChangeDateFilter('RegEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'regEpoch',
        minWidth: 150,
        resizable: false,
        sortable: true,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return (
            <div>
              <span className={cx('log-reg-date-normal')}>{moment.unix(value).format(dateFormat + ' HH:mm:ss')}</span>
              <span className={cx('log-reg-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          );
        }
      }
    ];

    if (isAuth === 2) {
      columns.splice(2, 0, {
        // 서비스No
        Header: <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'ExamTemplateList_18', defaultMessage: '서비스No' }))} />,
        accessor: 'serviceNo',
        sortable: true,
        resizable: false,
        minWidth: 80,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center number-text'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value) {
            printValue = value;
          }
          return printValue;
        }
      });

      columns.splice(
        13,
        0,
        {
          Header: (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamTemplateEdit_32', defaultMessage: '공개 여부' }))}
            />
          ),
          accessor: 'isPublic',
          id: 'isPublic',
          sortable: true,
          resizable: false,
          minWidth: 80,
          headerClassName: cx('react-table-th', 'overflow-visible'),
          className: cx('react-table-td', 'text-align-center'),
          Cell: ({ value }) => {
            let printValue = '-';
            if (value === 1) {
              printValue = 'O';
            }
            return printValue;
          }
        }
        // {
        //   Header: (
        //     <ReactTableHeaderText
        //       title={defineMessages(formatMessage({ id: 'ExamTemplateList_18', defaultMessage: '서비스No' }))}
        //     />
        //   ),
        //   accessor: 'serviceNo',
        //   resizable: false,
        //   sortable: true,
        //   width: 110,
        //   headerClassName: cx('react-table-th'),
        //   className: cx('react-table-td', 'text-align-center number-text'),
        //   Cell: ({ value }) => {
        //     let printValue = '-';
        //     if (value) {
        //       printValue = value;
        //     }
        //     return printValue;
        //   }
        // },
        // {
        //   Header: (
        //     <ReactTableHeaderText
        //       title={defineMessages(formatMessage({ id: 'AdminUserList_8', defaultMessage: '서비스명' }))}
        //     />
        //   ),
        //   accessor: 'serviceName',
        //   sortable: true,
        //   minWidth: 143,
        //   headerClassName: cx('react-table-th'),
        //   className: cx('react-table-td sub-text')
        // }
      );
    }

    const { TbodyComponent: tbadyWrapper } = ReactTableDefaults;
    return (
      <div className={cx('react-table-area', fromNowView ? 'from-now-view' : '')}>
        <ReactTableSearch
          searchObj={searchObj}
          listData={data}
          //필터 영역
          filters={{
            isBasicFilter: isBasicFilter,
            phishingLevelFilter: phishingLevelFilter,
            downloadTypeTemplateFilter: downloadTypeTemplateFilter
          }}
          cancleCheck={cancelCheck}
          filterClose={filterClose}
          executeFilter={executeFilter}
          onFilterCancel={onFilterCancel}
        />
        <div className={cx('react-table')}>
          <ReactTable
            columns={columns}
            data={data}
            sortable={false}
            filterable={false}
            showPagination={false}
            showPageSizeOptions={false}
            defaultSorted={[
              {
                id: 'regEpoch',
                desc: true
              }
            ]}
            loadingText={defineMessages(
              formatMessage({ id: 'ExamTemplateList_23', defaultMessage: '데이터 로딩중...' })
            )}
            LoadingComponent={({ ...rest }) => <Loading active={rest.loading} content={rest.loadingText} />}
            FilterComponent={({ ...rest }) => <div />}
            TbodyComponent={({ ...rest }) => (
              <div style={{ ...rest.style }} className={cx('react-table-tbody-wrapper')}>
                <tbadyWrapper
                  {...rest}
                  className={cx('rt-tbody', rest.className ? rest.className : '', data.length < 2 ? 'single' : '')}
                />
              </div>
            )}
            NoDataComponent={({ ...rest }) => (
              <div className={cx('noData-area')}>
                <Image src="/img/table/nodata_icon.png" />
                {defineMessages(formatMessage({ id: 'ExamTemplateList_24', defaultMessage: '데이터가 없습니다.' }))}
              </div>
            )}
            getTheadThProps={(state, rowInfo, column) => {
              const filter = [];
              if (column) {
                // 필터 처리
                if (typeof searchObj.filterData[column.id] !== 'undefined') {
                  filter.push('isFiltered');
                }
                // 정렬 제공 안하는 header
                if (!column.sortable) {
                  filter.push('no-sort');
                }

                return filter.length > 0
                  ? {
                      className: filter.join(' ')
                    }
                  : {};
              }
            }}
            getTrProps={(state, rowInfo, column) => {
              if (rowInfo && rowInfo.original && rowInfo.original.isEnable === 0) {
                return {
                  className: 'delete-item'
                };
              } else {
                return {};
              }
            }}
            minRows={data ? (data.length !== 0 && data.length < 2 ? 2 : data.length) : searchObj.defaultPageSize}
            {...rest}
          />
        </div>
        <ReactTablePagination
          currentPage={rest.page}
          totalPages={rest.pages ? rest.pages : 0}
          handlePagination={handlePagination}
        />
      </div>
    );
  }
}

export default injectIntl(PhishingTemplateList);



// WEBPACK FOOTER //
// ./src/script/components/phishingTemplate/PhishingTemplateList.js